import ACTIONS from '../../../store/actions';
import Utils from '../../../utils';
import store from '../../../store';
export default (function (_ref) {
  var microservice = _ref.microservice,
      routes = _ref.routes;
  return function (dispatch) {
    var cacheInvalidator = '';
    if (window && window.location) cacheInvalidator = '?sv=' + window.location.host; // let token = store.getState().auth.token;

    return dispatch({
      type: ACTIONS.USER_INFO_GET,
      request: {
        url: '/backend/userInfo' + cacheInvalidator
      }
    }).then(function (_ref2) {
      var body = _ref2.body;

      if (body) {
        var firstName = body.FirstName || '';
        var lastName = body.LastName || '';
        var email = body.Email;
        var userName = body.UserName;
        return dispatch({
          type: ACTIONS.USER_INFO_GET_RESOLVED,
          payload: {
            userName: userName,
            email: email,
            environmentName: body.EnvironmentName,
            environmentLogo: body.EnvironmentLogo,
            permissions: body.Permissions,
            userProfileImage: body.UserProfileImage,
            timezone: body.IanaTimezone,
            firstName: firstName,
            lastName: lastName
          }
        });
      }
    }).then(function (action) {
      if (action.payload && action.payload.environmentName) {
        var environmentName = action.payload.environmentName;

        if (routes) {
          //persist params in URL
          Utils.auth.ensureParametersInUrl(routes.history, routes.location, microservice, {
            environmentName: environmentName
          });
        } //update auth store slice


        dispatch({
          type: ACTIONS.AUTH_SET,
          payload: {
            environmentName: environmentName
          }
        }); //token validated, persist it in storage

        Utils.auth.saveToStorage({
          token: undefined,
          environmentName: action.payload.environmentName
        });
      }
    }).catch(function (error) {
      return dispatch({
        type: ACTIONS.USER_INFO_GET_FAILED,
        payload: error
      });
    });
  };
});